import { gate } from 'hub-http/gates';
import type { PersonalizedTokenStyles } from '../commands/InsertPersonalizationToken';
import type { EditorConfig } from '../editorCapabilities/editorCapabilitiesTypes';
import { PERSONALIZATION_TOKEN } from '../editorCapabilities/constants';

export const PERSONALIZATION_TOKENS_P2 = gate(
  'CommPlatform:TeamSignature:ShowInCRM'
);

export function personalizationTokenStylesToString(
  tokenStyles: PersonalizedTokenStyles
) {
  return (
    Object.keys(tokenStyles)
      .map(
        (key) => `${key}: ${tokenStyles[key as keyof PersonalizedTokenStyles]}`
      )
      .join('; ') || undefined
  );
}

export function personalizationTokenStylesFromString(tokenStylesStr?: string) {
  const tokenStyles: PersonalizedTokenStyles = {};
  tokenStylesStr?.split(';').forEach((styleStr) => {
    const [__, key, value] =
      styleStr.match(
        /(margin|padding|fontColor|borderColor|backgroundColor|tokenIconKey): ([\w\-#()\s]+)/
      ) || [];
    if (key) tokenStyles[key as keyof PersonalizedTokenStyles] = value;
  });
  return tokenStyles;
}

export function formatPersonalizationToken(
  tokenKey: string,
  defaultTokenValue?: string
) {
  if (defaultTokenValue) {
    return `{{ ${tokenKey}|default('${defaultTokenValue}') }}`;
  }

  return `{{ ${tokenKey} }}`;
}

export function parseDefaultValueFromDOM(tokenKey: string | null, el: Element) {
  if (!tokenKey) return null;
  const tokenText = el.textContent || '';

  const defaultStart = tokenText.indexOf("|default('");
  if (defaultStart === -1) return null;

  const valueStart = defaultStart + "|default('".length;
  const valueEnd = tokenText.indexOf("')", valueStart);
  if (valueEnd === -1) return null;

  return tokenText.substring(valueStart, valueEnd);
}

export const formatDisplayText = (tokenKey: string) => {
  return tokenKey
    .replace(/\./g, ':')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export function getTokenTooltip(
  editorConfig: EditorConfig | undefined,
  tokenKey: string
) {
  const tokensConfig = editorConfig?.[PERSONALIZATION_TOKEN];

  return tokensConfig?.tokenTooltips?.[tokenKey] || null;
}
